var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdapt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,3H9C7.3,3,6,4.3,6,6v0c0,1.7,1.3,3,3,3h17v20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,29H9c-1.7,0-3-1.3-3-3v0V6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26,
    y1: 6,
    x2: 9,
    y2: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "11,9 11,21 14,20 17,21 17,9 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdapt);
export default __webpack_public_path__ + "static/media/adapt.17ce169e6c0ac69ae9fb806eaf6ab7f8.svg";
export { ForwardRef as ReactComponent };